/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.identity.defs'

export { $nsid }

type IdentityInfo = {
  $type?: 'com.atproto.identity.defs#identityInfo'
  did: l.DidString

  /**
   * The validated handle of the account; or 'handle.invalid' if the handle did not bi-directionally match the DID document.
   */
  handle: l.HandleString

  /**
   * The complete DID document for the identity.
   */
  didDoc: l.LexMap
}

export type { IdentityInfo }

const identityInfo = /*#__PURE__*/ l.typedObject<IdentityInfo>(
  $nsid,
  'identityInfo',
  /*#__PURE__*/ l.object({
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    handle: /*#__PURE__*/ l.string({ format: 'handle' }),
    didDoc: /*#__PURE__*/ l.lexMap(),
  }),
)

export { identityInfo }
